import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(whitelabel)/rac/(web)/error.tsx");
